module.exports = __webpack_public_path__ + "img/flexsale-refined-2.0948f2f5.png";